import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbRestBaseUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbRestBaseUrl.tsx';
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { ActionApi, InstantiatedBundle } from './ActionApi.types.tsx';

const getFetchCdmInstantiationsUrl = (workspaceId: string, type: string): string => {
	const base = getCmdbRestBaseUrl(workspaceId);
	return `${base}/bundle/instantiated?type=${type}`;
};
export const fetchCdm =
	(): ActionApi =>
	async ({ setState, getState }, { workspaceId }) => {
		// First reset state to undefined to indicate loading
		const initialState = getState();
		setState({
			...initialState,
			cdm: {
				...initialState.cdm,
				instantiations: undefined, // Reset to undefined while loading
			},
		});

		let instantiationsResponse: InstantiatedBundle[];
		try {
			const bundleType = fg('assets_tempeh_update_cdm_to_foundations') ? 'foundations' : 'cdm';
			const apiResponse = await performCmdbGetRequest(
				getFetchCdmInstantiationsUrl(workspaceId, bundleType),
			);

			instantiationsResponse = apiResponse?.instantiations || [];
		} catch (error) {
			fireCmdbErrorAnalytics({
				error: error instanceof Error ? error : new Error('Unknown error'),
				meta: {
					id: 'fetchInstantiations',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
			});

			// TODO(KKT-103) : handle error scenario by surfacing it to the user or retrying
			instantiationsResponse = [];
		}

		const state = getState();

		setState({
			...state,
			cdm: {
				...state.cdm,
				instantiations: instantiationsResponse,
			},
		});
	};
